import React from 'react';
import { makersExperience } from '@fiverr-private/logo_maker_analytics/dist/esm/mixpanel';
import monitor from '../../../service/bigquery';
import topLevelSource from '../../../shared/storage/topLevelSource';
import { UserAgentContext } from '../../../shared/components/UserAgentContext';
import { useOnceBeforeRender } from '../../../shared/hooks';
import { INTEGRATIONS_MAP } from '../constants';
import IntegrationLandingPage from '../components/IntegrationLandingPage';

const { fromBoost, pageType } = makersExperience.integrationLandingPage.store;

export default function ClientIntegrationLandingPagePage({
    userAgent,
    industriesTags,
    integration,
    tracking,
    mixpanel,
}) {
    useOnceBeforeRender(() => {
        fromBoost.setData(mixpanel.fromBoost);
        pageType.setData(INTEGRATIONS_MAP[integration]?.TOP_LEVEL_SOURCE);

        monitor.initialize(tracking);

        // Set mark in the localStorage to mark a user as they came from the Makers landing page
        topLevelSource.setTopLevelSourceInStorage(
            INTEGRATIONS_MAP[integration]?.TOP_LEVEL_SOURCE
        );
    });

    return (
        <UserAgentContext.Provider value={userAgent}>
            <IntegrationLandingPage
                pageCtxId={tracking.pageCtxId}
                integration={integration}
                industriesTags={industriesTags}
            />
        </UserAgentContext.Provider>
    );
}
